import { render, staticRenderFns } from "./CreateMail.vue?vue&type=template&id=b4d888e2&scoped=true&"
import script from "./CreateMail.vue?vue&type=script&lang=ts&"
export * from "./CreateMail.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMail.vue?vue&type=style&index=0&id=b4d888e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d888e2",
  null
  
)

export default component.exports